__turbopack_context__.v({
  "buttonBox": "_6LkiBq_buttonBox",
  "checkBox": "_6LkiBq_checkBox",
  "groupButton": "_6LkiBq_groupButton",
  "headerNewsletter": "_6LkiBq_headerNewsletter",
  "inputBox": "_6LkiBq_inputBox",
  "modal": "_6LkiBq_modal",
  "msgBlock": "_6LkiBq_msgBlock",
  "newLetterContainer": "_6LkiBq_newLetterContainer",
  "newsLettetPb": "_6LkiBq_newsLettetPb",
  "newsletter-modal-content": "_6LkiBq_newsletter-modal-content",
  "newsletter-modal-header": "_6LkiBq_newsletter-modal-header",
  "newsletterAddImage": "_6LkiBq_newsletterAddImage",
});
